import { render, staticRenderFns } from "./SubmitVerify.vue?vue&type=template&id=ddd1a4d4&scoped=true"
import script from "./SubmitVerify.vue?vue&type=script&lang=js"
export * from "./SubmitVerify.vue?vue&type=script&lang=js"
import style0 from "./SubmitVerify.vue?vue&type=style&index=0&id=ddd1a4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd1a4d4",
  null
  
)

export default component.exports